export const USER_DATA_GET = 'USER_DATA_GET'
export const USER_DATA_GET_LOAD = 'USER_DATA_GET_LOAD'
export const USER_DATA_GET_SUCCESS = 'USER_DATA_GET_SUCCESS'
export const USER_DATA_GET_FAILED = 'USER_DATA_GET_FAILED'
export const USER_DATA_SET = 'USER_DATA_SET'
export const USER_DATA_SET_LOAD = 'USER_DATA_SET_LOAD'
export const USER_DATA_SET_SUCCESS = 'USER_DATA_SET_SUCCESS'
export const USER_DATA_SET_FAILED = 'USER_DATA_SET_FAILED'
